module.exports = __webpack_public_path__ + "img/04-B02.0532185c.png";